module.exports = __webpack_public_path__ + "static/img/icon_common.df4a171.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/icon_common.png
// module id = 113
// module chunks = 1